import { createFileRoute, notFound, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { Trash2 } from "lucide-react";
import { CategoryForm } from "@/components/admin/category-form";
import { adminCategoryQuery, adminDeleteCategory } from "@/lib/admin/categories.functions";

export const Route = createFileRoute("/admin/categorias/$id")({
  loader: async ({ context, params }) => {
    const category = await context.queryClient.ensureQueryData(adminCategoryQuery(params.id));
    if (!category) throw notFound();
    return category;
  },
  component: EditarCategoriaPage,
});

function EditarCategoriaPage() {
  const category = Route.useLoaderData();
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState("");

  const handleDelete = async () => {
    if (!window.confirm(`Excluir a categoria "${category.name}" permanentemente?`)) return;
    setDeleting(true);
    setDeleteError("");
    try {
      await adminDeleteCategory({ data: category.id });
      navigate({ to: "/admin/categorias" });
    } catch (err) {
      setDeleteError(err instanceof Error ? err.message : "Não foi possível excluir a categoria.");
      setDeleting(false);
    }
  };

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-display text-2xl font-bold text-eg-dark">Editar Categoria</h1>
        <button
          type="button"
          onClick={handleDelete}
          disabled={deleting}
          className="inline-flex items-center gap-2 rounded-md border border-red-600 px-4 py-2 text-sm font-semibold text-red-600 hover:bg-red-600 hover:text-white disabled:opacity-60 transition-colors"
        >
          <Trash2 className="h-4 w-4" />
          Excluir
        </button>
      </div>
      {deleteError && <p className="mb-4 text-xs text-red-600">{deleteError}</p>}
      <CategoryForm category={category} />
    </div>
  );
}
